export enum RoleEnum {
  PROGRAMMER = 1,
  CRC = 2,
  CRA = 3,
  DM = 4,
  INVESTIGATOR = 5,
  ADMIN = 6,
  READ_ONLY = 7,
  LAB_CRC = 9,
  SYSTEM_ADMIN = 10,
  APPROVER = 11,
  REVIEWER = 12,
  SPONSOR = 13,
  UPLOADER = 14,
  MEDICAL_CODER = 16,
  MEDICAL_REVIEWER = 17,
}